import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';
import { useWorkspaceUsers } from '@/hooks/api/0150_workspace_users';
import { useProducts } from '@/hooks/api/0390_products';
import { useSalesContexts } from '@/hooks/api/2130_sales_contexts';
import { useMenuListedTeams } from '@/hooks/api/2260_menu_listed_teams';

export const SearchConditionTags = () => {
  const { _w_ } = useCurrentWorkspace();
  const { plDashboardSearchCondition: searchCondition } = useDashboardSearchCondition();
  const { data: users } = useWorkspaceUsers({ identifier: _w_!.identifier });
  const { data: teams } = useMenuListedTeams({ identifier: _w_!.identifier });

  return (
    <div className="d-flex mb-4 align-items-center flex-wrap">
      {searchCondition.fiscal_year == 1 && <span className="badge rounded-pill badge-info mx-1 my-1">前年度</span>}
      {searchCondition.fiscal_year == 0 && <span className="badge rounded-pill badge-info mx-1 my-1">今年度</span>}
      {searchCondition.fiscal_year == 2 && <span className="badge rounded-pill badge-info mx-1 my-1">翌年度</span>}
      {teams &&
        teams.purchase_order_teams
          .filter((d) => searchCondition.team_ids.includes(d.id))
          .map((d) => (
            <span key={`pm-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {users &&
        users
          .filter((d) => searchCondition.user_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.user_account.name}
            </span>
          ))}
      {searchCondition.use_external_expense ? (
        <span className="badge rounded-pill badge-primary mx-1 my-1">Node管理外費用を表示する</span>
      ) : (
        <span className="badge rounded-pill badge-secondary mx-1 my-1">Node管理外費用を表示しない</span>
      )}
    </div>
  );
};
